// extracted by mini-css-extract-plugin
export default {"task-state-tabs":"task-state-tabs_task-state-tabs__u7A2O"};